import { render, staticRenderFns } from "./OnboardingWorkingHoursPage.vue?vue&type=template&id=6be404f2"
import script from "./OnboardingWorkingHoursPage.vue?vue&type=script&lang=ts"
export * from "./OnboardingWorkingHoursPage.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingWorkingHoursPage.vue?vue&type=style&index=0&id=6be404f2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports